import React from 'react';

export default function ChartLegend({ seriesKeys, isolatedSeries, onToggleSeries, colorForSeries }) {
  return (
    <div className="re-legend-row">
      {seriesKeys.map(function (seriesKey, index) {
        var isActive = !isolatedSeries || isolatedSeries === seriesKey;
        return (
          <button
            key={seriesKey}
            type="button"
            className={isActive ? 're-legend-item' : 're-legend-item re-legend-item-inactive'}
            onClick={function onClick() {
              onToggleSeries(seriesKey);
            }}
          >
            <span style={{ background: colorForSeries(seriesKey, index) }} className="re-legend-dot" />
            <span>{seriesKey}</span>
          </button>
        );
      })}
    </div>
  );
}
